import { render, staticRenderFns } from "./MessagesSetting.vue?vue&type=template&id=eb2b1bd6&"
import script from "./MessagesSetting.vue?vue&type=script&lang=js&"
export * from "./MessagesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports